// utils/tenant.js
import { Link } from "react-router-dom";
import DefaultData from "../CompanyData/DefaultData";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/effect-fade";
//import "./GlobalSupplier.css"; // Import the CSS file
const supplierLogos = [
  "tbo.png",
  "tripjack.png",
  "airiq.png",
  "Riya.png",
  "rezlive.png",
];
export default function LoginScreenLeftSide() {
  const featureSlides = [
  {
    heading: "Launch Your Online Travel Business in Days",
    title: "Build Your Own Travel Website with",
    subtitle: "Powerful Global Supplier Integrations",
    desc: "Go live instantly with top suppliers like TBO, TripJack, Akbar, Riya, AirIQ, RezLive and more — no technical hassle."
  },
  {
    heading: "Never Lose Customers to High Prices",
    title: "Compare Multiple Supplier Fares in Seconds",
    subtitle: "Always Offer the Best Price to Your Clients",
    desc: "Automatically fetch and compare fares from TripJack, TBO, Riya, Mystifly and others to maximize your bookings."
  },
  {
    heading: "Create Travel Packages in Seconds with AI",
    title: "AI-Powered Itinerary Builder for Travel Agents",
    subtitle: "Design Complete Trips Instantly",
    desc: "Generate ready-to-sell holiday packages with flights, hotels and activities in just one click."
  },
  {
    heading: "Turn WhatsApp into a Booking Machine",
    title: "AI WhatsApp Chatbot for Travel Agencies",
    subtitle: "Convert Enquiries into Confirmed Bookings",
    desc: "Engage customers 24/7, answer queries instantly and capture high-quality leads automatically."
  },
  {
    heading: "Capture Leads from Every Channel",
    title: "Social Media to CRM Integration",
    subtitle: "Manage Leads, Follow-ups & Customers Easily",
    desc: "Automatically collect enquiries from Facebook, Instagram and more into one powerful dashboard."
  },
  {
    heading: "Complete Financial Control for Your Agency",
    title: "Smart Accounting System Built for Travel Business",
    subtitle: "Track Payments, Profits & Ledgers in One Place",
    desc: "Manage invoices, supplier payments, customer balances and reports without using multiple tools."
  }
];
  return (
    <div style={{ maxWidth: "700px" }}>
      <Swiper
        modules={[Autoplay, EffectFade]}
        autoplay={{ delay: 10000 }}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        loop={true}
        pagination={{
        clickable: true,
       }}
      >
        {featureSlides.map((slide, index) => (
          <SwiperSlide key={index}>
              <div className="globalsupplier-hero-badge">
                <i className="ri-handshake-line"></i>
                {slide.heading}
              </div>
              <h3 className="globalsupplier-hero-title">
                {slide.title}
                <span className="globalsupplier-gradient-text">
                  {slide.subtitle}
                </span>
              </h3>
              <p className="text-white">{slide.desc}</p>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="custom-pagination"></div>
      <div className="globalsupplier-price-highlight">
        <div className="globalsupplier-price-tag">
          <span className="globalsupplier-price-label">
            Price Starting from
          </span>
          <span className="globalsupplier-price-value">2,999</span>
          <span className="globalsupplier-price-period">INR/month</span>
        </div>
        <div
          className="globalsupplier-hero-ctas"
          style={{ marginBottom: "0px" }}
        >
          <Link to="/" className="globalsupplier-hero-cta-primary">
            Start Free Trial <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="globalsupplier-trust-badges">
        <div className="globalsupplier-trust-item">
          <i className="ri-shield-check-line"></i>
          <span>No Credit Card Required</span>
        </div>
        <div className="globalsupplier-trust-item">
          <i className="ri-time-line"></i>
          <span>5-min Setup</span>
        </div>
        <div className="globalsupplier-trust-item">
          <i className="ri-customer-service-line"></i>
          <span>24/7 Support</span>
        </div>
      </div>
    </div>
  );
}
